import '../Tutorial.css';
import React from 'react';
import TutorialGirl from "../TutorialGirl";
import Typewriter from "typewriter-effect";

function T40PlayFirstCard() {

    /*
  useEffect(() => {
    UserService.sendEvent('PlayFirstCard40');
  }, []); */

const text = "Play the 'Fire' card from your hand. Simply tap or click on the card. 'Fire' is a mana card that increases your Fire mana growth by +1";
    return (
        <div>

            <div className='PlayCard40Right'>
            </div>



            <TutorialGirl position={'Right'}/>
            <div className='tutorialContainer tutorialTopContainerShoRes35'>
                <div className='tutorialBottomTextField'><Typewriter
                    options={{
                        delay: 30
                    }}
                    onInit={(typewriter) => {
                        typewriter.typeString(text).start();
                    }}
                /></div>
            </div>
        </div>

    );
}

export default T40PlayFirstCard;
